/**
 * Created by Mikhail Menshenin on 29.08.2024
 */

const RaidControlPanelView = cc.Node.extend({
    ctor: function (village, player, noAvatar) {
        this._super();
        this.village = village;

        const styles = cleverapps.styles.RaidControlPanelView;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);

        const nameBg = this.nameBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg);
        nameBg.setContentSize(styles.namePanel);
        nameBg.setAlignment(styles.namePanel);
        this.addChild(nameBg);

        const highlightBg = this.highlightBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg_highlight);
        highlightBg.setContentSize(styles.namePanel);
        highlightBg.setAlignment(styles.namePanel);
        this.addChild(highlightBg);
        highlightBg.setOpacity(0);

        const controlPanelBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg);
        controlPanelBg.setContentSize(styles);
        controlPanelBg.setPosition(this.width / 2, this.height / 2);
        this.addChild(controlPanelBg);

        const avatar = this.avatar = new cleverapps.UI.Avatar(player);
        avatar.setAlignment(styles.avatar);
        avatar.setScale(1.3);
        this.addChild(avatar);
        avatar.setVisible(!noAvatar);

        const nameText = this.nameText = cleverapps.UI.generateOnlyText("%{name}'s treasure:", cleverapps.styles.FONTS.RAID_NAME_TEXT, { name: player.name });
        nameText.setAlignment(styles.name);
        this.addChild(nameText);

        const goldText = this.goldText = new TextWithIcon(`${aisensia.getNumberWithCommas(player.gold)} ${TextWithIcon.ICONS_BY_NAME.hard}`, styles.gold.options);
        goldText.setAlignment(styles.gold);
        this.addChild(goldText);

        const labelText = this.labelText = cleverapps.UI.generateOnlyText("You stole:", cleverapps.styles.FONTS.RAID_NAME_TEXT);
        labelText.setAlignment(styles.label);
        nameBg.addChild(labelText);

        const earnedText = this.earnedText = new TextWithIcon(`0 ${TextWithIcon.ICONS_BY_NAME.hard}`, styles.earned.options);
        earnedText.setAnchorPoint(0, 0);
        earnedText.setAlignment(styles.earned);
        nameBg.addChild(earnedText);
        earnedText.setCascadeOpacityEnabledRecursively(true);
        this.goldCollectedAlready = village.goldCollected || 0;
        earnedText.setString(`${aisensia.getNumberWithCommas(village.goldCollected)} ${TextWithIcon.ICONS_BY_NAME.hard}`);

        cleverapps.aims.registerTarget("earnedText", earnedText, {
            controls: "earnedText",
            noTargetDelta: true
        });

        village.on("changeGoldCollected", this.countGoldCollected.bind(this), this);
        village.on("animateGoldHighlight", this.animateGoldHighlight.bind(this), this);

        this.setContentSize(controlPanelBg.getContentSize());
    },

    showSlotMachine: function (cb) {
        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(1),
            new cc.CallFunc(() => {
                this.nameText.setOpacity(0);
                this.goldText.setOpacity(0);
                this.goldText.setVisible(false);
                this.labelText.setVisible(false);
                this.earnedText.setVisible(false);
                this.nameBg.setVisible(false);
            }),
            new cc.MoveBy(0, 0, this.height),
            new cc.DelayTime(0.5),
            new cc.Show(),
            new cc.MoveBy(0.3, 0, -this.height).easing(cc.easeOut(3)),
            new cc.CallFunc(this.showRaidedBlock.bind(this)),
            new cc.DelayTime(cb ? 1.2 : 0),
            new cc.CallFunc(() => {
                if (cb) {
                    cb();
                }
            })
        ));
    },

    showRaidScene: function (cb) {
        this.labelText.setOpacity(0);
        this.earnedText.setOpacity(0);
        this.nameBg.runAction(new cc.Sequence(
            new cc.MoveBy(0, 0, this.nameBg.height),
            new cc.DelayTime(2.8),
            new cc.MoveBy(0.2, 0, -this.nameBg.height).easing(cc.easeOut(3)),
            new cc.CallFunc(this.showStealBlock.bind(this)),
            new cc.DelayTime(cb ? 2 : 0),
            new cc.CallFunc(() => {
                if (cb) {
                    cb();
                }
            })
        ));
    },

    hide: function () {
        this.runAction(new cc.Sequence(
            new cc.MoveBy(0.3, 0, this.height).easing(cc.easeIn(3)),
            new cc.Hide()
        ));
    },

    showRaidedBlock: function () {
        this.avatar.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                this.avatar.setVisible(true);
            })
        ));

        this.nameText.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.FadeIn(0.2)
        ));

        this.goldText.runAction(new cc.Sequence(
            new cc.DelayTime(0.6),
            new cc.CallFunc(() => {
                this.goldText.setVisible(true);
            }),
            new cc.FadeIn(0.2)
        ));
    },

    showStealBlock: function () {
        this.labelText.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.FadeIn(0.1)
        ));

        this.earnedText.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.FadeIn(0.1)
        ));
    },

    countGoldCollected: function (cb) {
        const from = this.goldCollectedAlready;
        const to = this.village.goldCollected;
        const steps = 15;

        const actions = [new cc.PlaySound(bundles.main.urls.count_coins)];
        for (let i = 1; i <= steps; i++) {
            actions.push(new cc.CallFunc(this.setEarned.bind(this, Math.round((from + (to - from) * i / steps) / 1000) * 1000)));
            actions.push(new cc.DelayTime(0.5 / steps));
        }
        actions.push(new cc.CallFunc(() => {
            this.goldCollectedAlready = to;
            cb && cb();
        }));

        this.earnedText.runAction(new cc.Sequence(actions));
    },

    setEarned: function (value) {
        this.earnedText.setString(`${aisensia.getNumberWithCommas(value)} ${TextWithIcon.ICONS_BY_NAME.hard}`);
    },

    animateGoldHighlight: function () {
        this.highlightBg.runAction(new cc.Sequence(
            new cc.FadeTo(0.2, 220),
            new cc.FadeOut(0.2)
        ));
    },

    animateRaidPlayer: function (cb) {
        this.labelText.setVisible(false);
        this.earnedText.setVisible(false);

        const position = this.getPosition();
        this.setPosition(position.x, position.y + this.height);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.MoveBy(0.1, 0, -this.height).easing(cc.easeOut(1)),
            new cc.DelayTime(0.8),
            new cc.CallFunc(cb || (() => { }))
        ));

        this.nameText.setOpacity(0);
        this.nameText.runAction(new cc.Sequence(
            new cc.DelayTime(0.6),
            new cc.FadeIn(0.1)
        ));

        this.goldText.setCascadeOpacityEnabledRecursively(true);
        this.goldText.setOpacity(0);
        this.goldText.setScale(0);
        this.goldText.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            new cc.Spawn(
                new cc.FadeIn(0.1),
                new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut())
            )
        ));
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RAID_GOLD_TEXT: {
        name: "nostroke",
        size: 36,
        color: new cc.Color(73, 167, 65),
        stroke: undefined,
        shadow: undefined
    },
    RAID_NAME_TEXT: {
        name: "nostroke",
        size: 36,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.RaidControlPanelView = {
    width: 688,
    height: 260,

    avatar: {
        x: { align: "left", dx: 28 },
        y: { align: "center", dy: -12 },

        padding: {
            x: 10,
            top: 8,
            bottom: 12
        }
    },

    name: {
        x: { align: "left", dx: 204 },
        y: { align: "center", dy: 16 }
    },

    gold: {
        x: { align: "left", dx: 204 },
        y: { align: "center", dy: -60 },

        options: {
            font: cleverapps.styles.FONTS.RAID_GOLD_TEXT
        }
    },

    label: {
        x: { align: "center", dx: -95 },
        y: { align: "center", dy: -27 }
    },

    earned: {
        x: { align: "center", dx: 65 },
        y: { align: "center", dy: -27 },

        options: {
            font: cleverapps.styles.FONTS.RAID_GOLD_TEXT
        }
    },

    namePanel: {
        x: { align: "center" },
        y: { align: "bottom", dy: -80 },

        width: 535,
        height: 150
    }
};